// Please keep sorted.
export default {
  GUTTER_WIDTH: 24,
};
